import { STANDARD_MEAL_SERVING_SIZE } from 'lib/constants';
import * as ErrorLogging from 'services/ErrorLogging';
import RequestService from 'services/RequestService';

import { PICK_MEALS_DEFAULT_WEEKLY_MEALS } from './internalSkipFunctions';

const DELIVERY_DAY_UNAVAILABLE_ERROR = 'delivery day';

export const getPickMealsRecommendation = async () => {
  try {
    const response = await RequestService.getRecommendedBox();

    if (response?.ok) {
      return {
        servings: response.recommendedServings || STANDARD_MEAL_SERVING_SIZE,
        weeklyMeals: response.recommendedMeals || PICK_MEALS_DEFAULT_WEEKLY_MEALS,
      };
    }
  } catch (error) {
    ErrorLogging.captureException(error.message);
  }

  return {
    servings: STANDARD_MEAL_SERVING_SIZE,
    weeklyMeals: PICK_MEALS_DEFAULT_WEEKLY_MEALS,
  };
};

export const getFirstAvailableDeliveryDate = async ({
  zipCode,
  pickYourMeals = false,
  setError,
}) => {
  if (!zipCode) {
    setError?.('Missing zip code for delivery options.');
    return null;
  }

  try {
    const response = await RequestService.getDeliveryOptions({
      params: { zipCode, pickYourMeals },
    });

    if (!response?.ok) {
      setError?.(response?.error);
      return null;
    }

    const firstDeliveryDate =
      response?.deliveryOptions?.firstDeliveryWeeks?.[0]?.firstDeliveryDays?.[0]?.value;

    if (!firstDeliveryDate) {
      setError?.('No delivery dates available.');
      return null;
    }

    return firstDeliveryDate;
  } catch (error) {
    setError?.(error.message);
    ErrorLogging.captureException(error.message);
    return null;
  }
};

export const createCheckoutWithDeliveryDateRetry = async ({
  paymentParams,
  deliveryOptionsParams,
  setError,
}) => {
  const createCheckoutResponse = await RequestService.createCheckout({ params: paymentParams });

  if (
    createCheckoutResponse?.ok ||
    !createCheckoutResponse?.error?.toLowerCase?.().includes(DELIVERY_DAY_UNAVAILABLE_ERROR)
  ) {
    return createCheckoutResponse;
  }

  const refreshedFirstDeliveryDate = await getFirstAvailableDeliveryDate({
    ...deliveryOptionsParams,
    setError,
  });

  if (
    !refreshedFirstDeliveryDate ||
    refreshedFirstDeliveryDate === paymentParams.firstDeliveryDate
  ) {
    return createCheckoutResponse;
  }

  return RequestService.createCheckout({
    params: {
      ...paymentParams,
      firstDeliveryDate: refreshedFirstDeliveryDate,
    },
  });
};
